'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTails = getTails;
exports.transformTails = transformTails;

var _types = require('../types');

var _blocks = require('./blocks');

var _destructure = require('./destructure');

// c/p babel-traverse/src/path/family.js getCompletionRecords

// Locate all Babel traversal paths that are in tail position with
// respect to the node at the given starting path.
function getTails(path, allowLoops) {
  var node = path.node;
  var paths = [];

  function add(_path) {
    if (_path) return paths = paths.concat(getTails(_path, allowLoops));
  }
  if ((0, _types.isa)(node, "IfStatement")) {
    add(path.get("consequent"));
    add(path.get("alternate"));
  } else if ((0, _types.isa)(node, "LabeledStatement")) {
    add(path.get("body"));
  } else if ((0, _types.isa)(node, "DoExpression")) {
    add(path.get("body"));
  } else if (allowLoops && ((0, _types.isa)(node, "For") || (0, _types.isa)(node, "While"))) {
    add(path.get("body"));
  } else if ((0, _types.isa)(node, "Program") || (0, _types.isa)(node, "BlockStatement")) {
    add(path.get("body").pop());
  } else if ((0, _types.isa)(node, "TryStatement")) {
    add(path.get("block"));
    add(path.get("handler"));
    add(path.get("finalizer"));
  } else if ((0, _types.isa)(node, "MatchStatement")) {
    for (var _arr2 = node.cases, _i2 = 0, _len3 = _arr2.length; _i2 < _len3; _i2++) {
      add(path.get(`cases.${_i2}.consequent`));
    }
  } else {
    paths.push(path);
  }return paths;
}function transformTails(path, allowLoops, allowExprs, getNewNode) {
  var tailPaths = getTails(path, allowLoops);

  for (var _i3 = 0, _len4 = tailPaths.length; _i3 < _len4; _i3++) {
    var _tailPath = tailPaths[_i3];
    if (allowExprs && (0, _types.isa)(_tailPath, "Expression")) {
      _tailPath.replaceWith(getNewNode(_tailPath.node, _tailPath));
    } else if ((0, _types.isa)(_tailPath, "ExpressionStatement")) {
      _tailPath.replaceWith((0, _blocks.toStatement)(getNewNode(_tailPath.node.expression, _tailPath)));
    } else if ((0, _types.isa)(_tailPath, "VariableDeclaration")) {
      var decls = _tailPath.node.declarations;

      var lhs = decls[0].id;
      var transformedNode = (0, _destructure.isDestructuringPattern)(lhs) ? (0, _destructure.toRestructureExpression)(lhs) : lhs;

      _tailPath.insertAfter((0, _blocks.toStatement)(getNewNode(transformedNode, _tailPath)));
    } else if ((0, _types.isa)(_tailPath, "FunctionDeclaration")) {
      _tailPath.insertAfter((0, _blocks.toStatement)(getNewNode(_tailPath.node.id, _tailPath)));
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ../~/@oigroup/babel-plugin-lightscript/lib/helpers/tails.js
// module id = 1001
// module chunks = 0